import {Link} from 'react-router-dom'
import '../styling/Navbar.css';

const Navbar = () => {
    return ( 

        <div className="navbar bg-base-100">
  <div className="navbar-start">
    <div className="dropdown" style={{visibility:"hidden"}}>
      <label tabIndex={0} className="btn btn-ghost lg:hidden">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
      </label>
      <ul tabIndex={0} className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52" >
        
      </ul>
    </div>
    <a className="btn btn-ghost text-xl" id="menunavbutton">InvoiceMaster Pro</a>
  </div>
  <div className="navbar-center hidden lg:flex">
    <ul className="menu menu-horizontal px-1">
    </ul>
  </div>
  <div className="navbar-end">
  <Link to="/signup" style={{textDecoration: 'none'}}>
    <a className="btn btn-primary mr-1.5" id="signupbutton">Sign up</a>
    </Link>
    <Link to="/login" style={{textDecoration: 'none'}}>
    <a className="btn">Sign in</a>
    </Link>
    
  </div>
</div>
     );
}
 
export default Navbar;